import { ClearingDepositInstrumentType } from '../../types/gql';
import { makeIds } from '../../utils/instrumentId';
import { RUB } from './components/RUB';
import { USD } from './components/USD';
import { CardInstrumentComponents } from './types';

export const supports = makeIds(ClearingDepositInstrumentType.BankCard, ['USD', 'RUB']);

export type CardInstrumentId = typeof supports[number];

export const subSchema: Record<CardInstrumentId, CardInstrumentComponents> = {
  BANK_CARD_RUB: RUB,
  BANK_CARD_USD: USD,
};
